import DataTable from "react-data-table-component";

interface Props {
    columns: any;
    data: any;
    paginationTotalRows?: number;
    onChangePage?: (page: number) => void;
    onChangeRowsPerPage?: (perPage: number, page: number) => void;
    onSort?: (column: any, sortDirection: any) => void;
    rowsPerPage?: number;

    selectableRows?: boolean;
    onSelectedRowsChange?: (selectedRows: { selectedRows: any[] }) => void;
    selectableRowsHighlight?: boolean;
    paginationDefaultPage?: number;
    progressPending?: boolean;
    conditionalRowStyles?: any[];
}

const defaultTableStyles = {
    head: {
        style: {
            backgroundColor: 'var(--primary-color, #2ca9b8)',
            color: '#ffffff',
            borderRadius: '5px 5px 0 0',
        },
    },
    headRow: {
        style: {
            backgroundColor: 'var(--primary-color, #2ca9b8)',
            borderRadius: '5px',
            height: '38px',
            minHeight: '38px',
            border: '0',
            color: '#ffffff',
        },
    },
    headCells: {
        style: {
            backgroundColor: 'transparent',
            color: '#ffffff',
            fontWeight: '600',
            fontSize: '13px',
            paddingLeft: '10px',
            paddingRight: '10px',
            '&:hover': {
                color: '#ffffff',
            },
        },
    },
};

export const ESDataTable = (props: Props) => {

    const {
        columns,
        data,
        paginationTotalRows,
        onChangeRowsPerPage,
        onChangePage,
        onSort,
        rowsPerPage,
        selectableRows,
        onSelectedRowsChange,
        selectableRowsHighlight,
        paginationDefaultPage,
        progressPending
    } = props;

    return (
        <>
            <DataTable
                columns={columns}
                data={data}
                highlightOnHover
                fixedHeader
                pagination
                paginationServer
                paginationTotalRows={paginationTotalRows}
                onChangeRowsPerPage={onChangeRowsPerPage}
                onChangePage={onChangePage}
                sortServer
                onSort={onSort}
                paginationPerPage={rowsPerPage ? rowsPerPage : Number(localStorage.getItem('PageRecordLimit'))}
                selectableRows={selectableRows}
                onSelectedRowsChange={onSelectedRowsChange}
                selectableRowsHighlight={selectableRowsHighlight}
                progressPending={progressPending}
                paginationDefaultPage={paginationDefaultPage}
                conditionalRowStyles={props.conditionalRowStyles}
                customStyles={defaultTableStyles}
            />
        </>
    );
};
 